import { useAccountInfo } from '@/hooks/query/account';
import { useQueryClient } from '@tanstack/react-query';
import { updateEventProgress } from '@/hooks/query/use-reward-system';
import { useEffect, useState } from 'react';

export const useCompletePromoteBookedBet = (): ()=>Promise<void> => {
	const { user, refetch } = useAccountInfo();
	const queryClient = useQueryClient();
	const [isPromoted, setIsPromoted] = useState<boolean>(user?.RewardInfo.PromoteBookedBet !== true);
	useEffect(() => {
		const currentlyIsPromoted = user?.RewardInfo.PromoteBookedBet !== true;
		if (currentlyIsPromoted !== isPromoted) {
			setIsPromoted(currentlyIsPromoted);
		}
	}, [user?.RewardInfo.PromoteBookedBet])
	return () => {
		if (isPromoted) {
			return Promise.resolve();
		}
		// return Promise.resolve();
		return updateEventProgress(user, queryClient, 8)
			.then(
				() => {
					refetch();
					return Promise.resolve();
				}
			)
	};
};